require('./bootstrap');

import { createApp } from 'vue';
import ClinicCalendar from './components/ClinicCalendar.vue';

const app = createApp({});
app.component('clinic-calendar', ClinicCalendar);

const clinicCalendarElement = document.getElementById('clinic_calendar');
if (clinicCalendarElement) {
    app.mount('#clinic_calendar');
}

//
// HERE BELOW IS THE OLD VUE 2 for reference
//

// window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// import ClinicCalendar from './components/ClinicCalendar.vue'

// if ( document.getElementById('clinic_calendar') ) {
//     new Vue({
//         el: '#clinic_calendar',
//         components: { 'clinic-calendar': ClinicCalendar },
//     })
// }